<template>
<q-dialog
  v-model="state.show"
  persistent
  maximized
  @hide="clear"
  ref="dialog"
  v-on:keyup="listen__this__onkeyup"
>
  <div class="column full-height full-width" style="background:rgb(237, 238, 242);padding:10px 20px;">
    <div style="flex:0 0 65px;">
      <div class="text-h6">
        {{ mode == 'create' ? "템플릿 생성" : "템플릿 수정" }}
        <q-btn dense flat icon="help_outline" @click="state.dialogTemplateCreation = true" size="xs" />
      </div>
      <div>특정 템플릿의 인식률 향상, SELVY OCR 성능 개선 상담, 템플릿 작성에 도움이 필요할 경우 <a href="mailto:johan.j.jo@selvas.com">기술지원</a>으로 문의해주세요.</div>
    </div>
    <card-layout style="flex:0 0 130px;">
      <template v-slot:header>
        <span class="text-primary text-weight-bolder" style="margin-right:5px;">템플릿 기본 정보</span>
        <span class="text-grey-6 text-caption">(*필수 입력 사항입니다.)</span>
      </template>
      <template v-slot:body>
        <div class="column col full-height">
          <div class="row col" style="align-items:flex-end">
            <div class="row col" style="align-items:center">
              <div>템플릿 명 <span class="text-primary text-weight-bold">*</span></div>
              <input v-model="state.templateName" placeholder="최소 1자 최대 30자" style="margin-left:15px;" />
            </div>
          </div>
          <div style="flex:0 0 10px" />
          <div class="row col" style="align-items:flex-start">
            <div class="row col" style="align-items:center">
              <div>인식 모델</div>
              <q-radio v-model="state.recognitionModel" val="Basic" label="Basic" size="xs" style="margin-left:18px;" />
              <q-radio v-model="state.recognitionModel" val="Premium" label="Premium" size="xs" disable />
            </div>
          </div>
        </div>
      </template>
    </card-layout>

    <div style="flex:0 0 15px;" />

    <card-layout class="col full-height full-width" :styles="{paddingBody: '0px 0px'}">
      <template v-slot:header>
        <div class="row full-width">
          <span class="text-primary text-weight-bolder" style="margin-right:5px;">판독 필드 설정</span>
          <q-btn dense flat icon="help_outline" @click="state.dialogRepresentativeSampleConfigure = true" size="xs" />
          <span class="text-grey-6 text-caption" style="margin-left:5px;">PNG/JPG 등 단일 페이지 이미지 지원</span>
          <q-space />
          <q-btn v-if="mode != 'create'" unelevated icon="published_with_changes" color="primary" label="샘플 이미지 변경" dense size="sm" style="" disable />
        </div>
      </template>
      <template v-slot:body>
        <div class="column col full-height full-width" style="padding:20px 20px;">
          <image-view ref="image-view" class="column col full-height full-width" style="border:1px solid rgb(224, 224, 224)"
            :template-data="templateData"
            :left-mouse-mode="state.leftMouseMode"
            :drawLabelText="state.drawLabelText"
            :drawPredictedText="false"
            @onframestatechange="listen__image_view__onframestatechange"
            @onfieldadd="listen__image_view__onfieldadd"
            @onfieldremove="listen__x__onfieldremove"
            @onfieldmove="listen__x__onfieldmove"
          />
        </div>
        <div class="column col full-height" style="border-left:1px solid rgb(224, 224, 224);max-width:450px;">
          <div style="flex:0 0 15px" />
          <div class="column" style="padding:0px 10px;">
            <div>
              <span class="text-weight-bold">도구</span>
              <q-btn dense flat icon="help_outline" @click="state.dialogTool = true" size="xs" />
            </div>
            <div style="flex:0 0 5px;" />
            <div class="column" style="padding:0px 15px;">
              <div class="row">
                <span class="text-caption text-grey-8">마우스 모드</span>
                <q-btn-group dense flat style="margin-left:15px;">
                  <q-btn :outline="state.leftMouseMode != 'pan'" icon="open_with" color="secondary" label="이동" dense size="sm" @click="setLeftMouseMode('pan')">
                    <q-tooltip>마우스 왼쪽 버튼을 드래그하여 이미지 기준점 이동<br/>단축키: Q</q-tooltip>
                  </q-btn>
                  <q-separator vertical />
                  <q-btn :outline="state.leftMouseMode != 'add'" icon="highlight_alt" color="secondary" label="필드 추가" dense size="sm" @click="setLeftMouseMode('add')">
                    <q-tooltip>마우스 왼쪽 버튼을 드래그하여 필드 영역을 추가<br/>단축키: W</q-tooltip>
                  </q-btn>
                  <q-btn :outline="state.leftMouseMode != 'edit'" icon="highlight_alt" color="secondary" label="필드 수정" dense size="sm" @click="setLeftMouseMode('edit')">
                    <q-tooltip>마우스 왼쪽 버튼을 드래그하여 기존 필드 영역을 이동시키거나 크기 수정<br/>단축키: E</q-tooltip>
                  </q-btn>
                </q-btn-group>
              </div>
              <div class="row" style="align-items:center;">
                <span class="text-caption text-grey-8">이미지 배율</span>
                <q-btn unelevated icon="fit_screen" color="primary" label="창에 맞게" dense size="sm" style="margin-left:14px;" @click="$refs['image-view'].fitToWindow()" />
                <q-slider
                  class="col"
                  :value="state.imageScale.value"
                  @change="listen__imageScale__onchange"
                  :min="state.imageScale.min"
                  :max="state.imageScale.max"
                  :step="5"
                  color="primary"
                  style="margin:0px 15px;"
                  label
                />
              </div>
              <div style="flex:0 0 2px;" />
              <div class="row">
                <span class="text-caption text-grey-8">필드 이름 표시</span>
                <q-toggle v-model="state.drawLabelText" color="primary" dense style="margin-left:21px;" />
              </div>
              <div style="flex:0 0 12px;" />
              <div class="row">
                <span class="text-caption text-grey-8">필드 목록 펼치기</span>
                <q-toggle v-model="state.fieldListUnfold" color="primary" dense style="margin-left:10px;" />
              </div>
            </div>
          </div>
          <div style="flex:0 0 15px" />
          <div class="column col" style="padding:0px 10px;">
            <div>
              <span class="text-weight-bold">판독 필드</span>
              <q-btn dense flat icon="help_outline" @click="state.dialogField = true" size="xs" />
            </div>
            <q-separator />
            <div v-if="fields.length == 0" class="column col" style="align-items:center;justify-content:center;">
              <q-icon name="warning" class="text-grey q-pa-sm" size="md" />
              <div class="text-grey" >[<q-icon name="highlight_alt" size="xs" />필드추가] 버튼을 클릭하여 판독 범위를 설정해주세요.</div>
            </div>
            <div v-else class="column col" style="overflow:auto;">
              <q-list ref="field-list">
                <template v-for="(field, index) in fields">
                  <field-list-item
                    :field="field"
                    :key="`field-${index}`"
                    :unfold="state.fieldListUnfold"
                    @onfieldremove="listen__x__onfieldremove"
                    @onfieldvaluechange="listen__x__onfieldvaluechange"
                    @ontoggle="listen__fieldItem__ontoggle"
                    @onfocus="listen__fieldItem__onfocus"
                  />
                  <q-separator v-if="index < fields.length - 1" :key="`sep-${index}`" />
                </template>
              </q-list>
            </div>
          </div>
          <div class="row" style="flex:0 0 50px;border-top:1px solid rgb(224, 224, 224);align-items:center;justify-content:center;">
            <q-btn unelevated dense color="red" label="취소" style="padding:0px 15px;" size="sm" @click="$emit('onclose')" />
            <div style="flex:0 0 10px;" />
            <q-btn v-if="mode == 'create'" unelevated ref="btnSave" dense color="secondary" label="생성" style="padding:0px 15px;" size="sm" @click="save" />
            <q-btn v-else unelevated ref="btnSave" dense color="secondary" label="수정" style="padding:0px 15px;" size="sm" @click="modify" />
          </div>
        </div>
      </template>
    </card-layout>
  </div>

  <!-- dialog -->
  <q-dialog v-if="mode == 'create'" v-model="state.dialogTemplateCreation">
    <q-card>
      <q-card-section>
        <div class="text-h6">템플릿 생성</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-else v-model="state.dialogTemplateCreation">
    <q-card>
      <q-card-section>
        <div class="text-h6">템플릿 수정</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="state.dialogRepresentativeSampleConfigure">
    <q-card>
      <q-card-section>
        <div class="text-h6">판독 필드 설정</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="state.dialogRepresentativeRecognitionField">
    <q-card>
      <q-card-section>
        <div class="text-h6">대표 샘플명</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="state.dialogTool">
    <q-card>
      <q-card-section>
        <div class="text-h6">도구</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="state.dialogField">
    <q-card>
      <q-card-section>
        <div class="text-h6">판독 필드</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>
</q-dialog>
</template>

<script>
/* eslint-disable no-unused-vars */
import CardLayout from '@/projects/template_ocr/components/CardLayout.vue'
import FieldListItem from '@/projects/template_ocr/components/FieldListItem.vue'
import ImageView from '@/projects/template_ocr/views/ImageView.vue'

import TEMPLATE from '@/js/template.js'
import COMM from '@/js/comm.js'
import MISC from '@/js/miscellaneous.js'

export default {
  props: {templateData: Object},
  components: {
    CardLayout,
    FieldListItem,
    ImageView
  },
  data: function () {
    const Vue = this
    const templateData = this.templateData
    let defaultData = {
      fieldColors: Vue.$store.state.constant.fieldColors,
      fieldColorIdx: 0
    }
    if (templateData == undefined) // template create
      return {
        state: {
          show: true,
          dialogTemplateCreation: false,
          dialogRepresentativeSampleConfigure: false,
          dialogRepresentativeRecognitionField: false,
          dialogTool: false,
          dialogField: false,
          loadingLayer: {
            show: false,
            message: ''
          },
          templateName: '',
          recognitionModel: 'Basic',
          leftMouseMode: 'pan',
          imageScale: {
            min: 20,
            max: 300,
            value: 100
          },
          drawLabelText: true,
          fieldListUnfold: false
        },
        mode: 'create',
        fields: [],
        ...defaultData
      }
    else { // template edit
      return {
        state: {
          show: true,
          dialogTemplateCreation: false,
          dialogRepresentativeSampleConfigure: false,
          dialogRepresentativeRecognitionField: false,
          dialogTool: false,
          dialogField: false,
          loadingLayer: {
            show: false,
            message: ''
          },
          templateName: templateData.template.templateName,
          recognitionModel: 'Basic',
          leftMouseMode: 'pan',
          imageScale: {
            min: 20,
            max: 300,
            value: 100
          },
          drawLabelText: true,
          fieldListUnfold: false
        },
        mode: 'edit',
        fields: templateData.template.fields,
        ...defaultData
      }
    }
  },
  methods: {
    listen__image_view__onframestatechange: function (e) {
      this.state.imageScale.value = parseInt(e.zoom * 100);
    },
    listen__imageScale__onchange(val) {
      this.state.imageScale.value = val
      this.$refs['image-view'].zoom(val / 100)
    },
    listen__image_view__onfieldadd(value) {
      const Vue = this;
      // console.log(value)
      Vue.fields.push(
        {
          id: value.id,
          name: value.name,
          color: this.$cornerstoneTools.toolColors.getToolColor(),
          type: '기본',
          rect: value.rect,
          dictionary: value.dictionary,
          language: value.language,
          writingType: value.writingType
        }
      );
      Vue.fieldColorIdx++;
      Vue.$cornerstoneTools.toolColors.setToolColor(Vue.fieldColors[Vue.fieldColorIdx % Vue.fieldColors.length]);
    },
    listen__x__onfieldremove: function (fieldId) {
      const idx = this.fields.map(v => v.id).indexOf(fieldId)
      if (idx != -1)
        this.$delete(this.fields, idx)

      this.$refs['image-view'].$refs['frame'].removeCtAnnotation(fieldId)
    },
    listen__x__onfieldmove: function (data) {
      const idx = this.fields.map(v => v.id).indexOf(data.id)
      if (idx != -1)
        this.fields[idx].rect = data.rect
    },
    listen__x__onfieldvaluechange: function (data) {
      const Vue = this
      const idx = this.fields.map(v => v.id).indexOf(data.id)
      if (idx != -1) {
        switch(data.key) {
          case 'type':
            Vue.fields[idx].type = data.value
            break
          case 'dictionary':
            Vue.fields[idx].dictionary = data.value
            break
          case 'language':
            Vue.fields[idx].language = data.value
            break
          case 'writingType':
            Vue.fields[idx].writingType = data.value
            break
        }
      }
    },
    listen__fieldItem__ontoggle: function (data) {
      let cnt = 0
      let cntUnfold = 0
      for (let vel of this.$refs['field-list'].$children) {
        if (vel.state != undefined) {
          cnt += 1
          cntUnfold = cntUnfold + (vel.state.unfold ? 1 : 0)
        }
      }
      if (cntUnfold == cnt)
        this.state.fieldListUnfold = true
      else if (cntUnfold == 0)
        this.state.fieldListUnfold = false
      else
        this.state.fieldListUnfold = 'intermediate'
    },
    listen__fieldItem__onfocus: function (rect) {
      this.$refs['image-view'].move(rect)
    },
    listen__this__onkeyup: function (e) {
      if (e.key == 'q')
        this.setLeftMouseMode('pan')
      else if (e.key == 'w')
        this.setLeftMouseMode('add')
      else if (e.key == 'e')
        this.setLeftMouseMode('edit')
    },
    setLeftMouseMode: function (value) {
      this.state.leftMouseMode = value
    },
    clear () {
      const Vue = this
      Vue.state.templateName = ''
      Vue.state.recognitionModel = 'Basic'
      Vue.state.leftMouseMode = 'pan'
      Vue.state.imageScale = {
        min: 20,
        max: 300,
        value: 100
      }
      Vue.fields = []
      Vue.fieldColorIdx = 0
      Vue.$cornerstoneTools.toolColors.setToolColor(Vue.fieldColors[0]);
    },
    async save () {
      if (this.fields.length == 0) {
        this.$q.notify({
          message: `적어도 하나 이상의 판독 영역이 지정 되어야 합니다.`,
          icon: 'announcement',
          color: 'purple'
        })
        return
      }
      else if (this.state.templateName == '') {
        let emptyFields = []
        if (this.state.templateName == '')
          emptyFields.push('"템플릿 명"')
        this.$q.notify({
          message: `'다음 필드를 기입해 주세요. ${emptyFields.join(', ')}`,
          icon: 'announcement',
          color: 'purple'
        })
        return
      }
      this.state.loadingLayer = {
        show: true,
        message: '템플릿을 생성하고 있습니다.'
      }
      const sampleFile = this.$refs['image-view'].state.files[0]
      let template = {
        version: '1.0.0',
        templateId: MISC.getUuid4(),
        sampleId: MISC.getUuid4(),
        sampleSize: this.$refs['image-view'].getImageSize(),
        sampleFileExtension: MISC.getFileExtension(sampleFile.name),
        templateName: this.state.templateName,
        creationBy: this.$store.state.user.value,
        creationDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' '),
        lastModifiedDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' '),
        fields: this.fields.map(v => TEMPLATE.trimField(v))
      }
      const base64Bytes = await COMM.toBase64(sampleFile);
      try {
        await COMM.postTemplate({template, sampleImage: base64Bytes})
      } catch (ret) {
        this.$q.notify({
          message: ret.message,
          icon: 'announcement',
          color: 'purple'
        })
        this.state.loadingLayer = {
          show: false
        }
        return
      }
      this.state.loadingLayer = {
        show: false
      }
      // this.$refs['dialog'].hide()
      this.$emit('onsave', {})
    },
    async modify () {
      if (this.fields.length == 0) {
        this.$q.notify({
          message: `적어도 하나 이상의 판독 영역이 지정 되어야 합니다.`,
          icon: 'announcement',
          color: 'purple'
        })
        return
      }
      else if (this.state.templateName == '') {
        let emptyFields = []
        if (this.state.templateName == '')
          emptyFields.push('"템플릿 명"')
        this.$q.notify({
          message: `'다음 필드를 기입해 주세요. ${emptyFields.join(', ')}`,
          icon: 'announcement',
          color: 'purple'
        })
        return
      }
      this.state.loadingLayer = {
        show: true,
        message: '템플릿을 수정하고 있습니다.'
      }

      let template = JSON.parse(JSON.stringify(this.templateData.template))
      template.lastModifiedDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' ')
      template.fields = this.fields.map(v => TEMPLATE.trimField(v))
      template.templateName = this.state.templateName
      try {
        await COMM.updateTemplate({template})
      } catch (ret) {
        this.$q.notify({
          message: ret.message,
          icon: 'announcement',
          color: 'red'
        })
        this.state.loadingLayer = {
          show: false
        }
        return
      }
      this.state.loadingLayer = {
        show: false
      }
      this.$emit('onmodify', {})
    }
  },
  mounted () {
    const Vue = this
    Vue.$cornerstoneTools.toolColors.setToolColor(Vue.fieldColors[0]);
  }
}
</script>
